<template>
  <div class="row">
    <div v-for="(name, i) in components" :key="i" :class="compClass">
      <component :is="name" />
    </div>
  </div>
</template>

<script>
import Balance from './Balance.vue'
import TariffCode from './TariffCode.vue'
import TariffCard from './TariffCard.vue'

export default {
  components: { Balance, TariffCode, TariffCard },
  computed: {
    compClass() {
      return 'col-xs-12 col-sm-6 col-md-4 col-lg-4'
    },
    components() {
      return ['Balance', 'TariffCode', 'TariffCard']
    },
  },
}
</script>
